import React from 'react';
import { Outlet } from 'react-router-dom';

export const SimpleProtectedLayout = () => {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <main className="">
        <Outlet />
      </main>
    </div>
  );
}; 